// extracted by mini-css-extract-plugin
module.exports = {"ButtonBase":"ButtonBase_ButtonBase__LbTBE","disabled":"ButtonBase_disabled__2orGK","block":"ButtonBase_block__1IQM0"};